import { __rest } from "tslib";
// @ts-expect-error
import { ITEM_TYPES } from '@wix/advanced-seo-utils/dist/src/private/types/ItemTypes';
import { getPostCover, toPlainText, buildPageUrl, getLastPage, } from '@wix/communities-forum-client-commons';
import contentStateToString from './utils/content-state-to-string';
import { getImageMetadataFromWixMedia, getVideoThumbnailMetadata, } from './utils/cover-image-utils';
import { getMediaData, toPlainTextSync } from '@wix/ricos';
const COMMENTING_TYPE_VOTE = 'vote';
const toPlainTextOptions = {
    urlShortener: () => '',
    getVideoUrl: () => '',
    getVideoEmbeddedUrl: () => '',
    getAudioUrl: () => '',
    getGifUrl: () => '',
    addLinksToText: false,
    delimiter: ' ',
};
export const decoratePostWithSeoAttributes = ({ post, postComments, sectionUrl, ownerProfileUrl, category, commentsPerPage = 20, buildDeepLink, }) => {
    const { content } = post, restOfPost = __rest(post, ["content"]);
    const buildFullUrl = () => `${sectionUrl}${buildPageUrl(category.slug, post.slug)}`; // TODO: check if not a problem with customUrl
    const buildPostPaging = () => {
        const totalComments = post.totalComments;
        const totalPages = getLastPage(totalComments, commentsPerPage);
        return {
            total: totalPages,
            totalComments,
        };
    };
    const contentString = 'nodes' in content
        ? toPlainTextSync(content, toPlainTextOptions)
        : contentStateToString(content);
    const postCover = getPostCover(post);
    const image = postCover.imageMetadata
        ? getImageMetadataFromWixMedia(postCover.imageMetadata)
        : null;
    const video = postCover.videoMetadata
        ? getVideoThumbnailMetadata(postCover.videoMetadata)
        : null;
    const postTitle = `${post.commentingType === COMMENTING_TYPE_VOTE &&
        Boolean(post.bestAnswerCommentId)
        ? '[SOLVED] '
        : ''}${post.title}`;
    return {
        itemType: ITEM_TYPES.FORUM_POST,
        itemData: {
            comments: Object.assign(Object.assign({}, getBestAnswerSEOStructuredData({
                comments: postComments,
                post,
                buildDeepLink,
            })), { lastFiveComments: postComments
                    .filter((comment) => comment.type === 'COMMENT')
                    .slice(0, 5)
                    .map((comment) => {
                    var _a;
                    return ({
                        id: comment._id,
                        parentId: comment.parentId,
                        postId: post._id,
                        upvoteCount: comment.upvoteCount,
                        createdDate: comment.createdDate,
                        editedDate: comment.editedDate,
                        replyCount: comment.replyCount,
                        contentText: 'nodes' in comment.content
                            ? toPlainTextSync(comment.content, toPlainTextOptions)
                            : toPlainText(comment.content),
                        url: buildDeepLink(comment._id),
                        score: comment.score,
                        content: comment.content,
                        marked: comment.isMarked,
                        owner: ((_a = comment.owner) === null || _a === void 0 ? void 0 : _a.name)
                            ? {
                                type: 'member',
                                name: comment.owner.name,
                            }
                            : {
                                type: 'guest',
                            },
                    });
                }) }),
            post: Object.assign(Object.assign({}, restOfPost), { owner: Object.assign(Object.assign({}, post.owner), { profile: {
                        url: ownerProfileUrl,
                    } }), title: postTitle, description: contentString, contentText: contentString, images: image ? [image] : [], videos: video ? [video] : [], refersTo: buildFullUrl(), url: buildFullUrl(), mediaItems: extractMediaItems({
                    content,
                    videoUploadDate: post.createdDate,
                }), paging: buildPostPaging() }),
            category: {
                label: category.label,
            },
        },
    };
};
const getBestAnswerSEOStructuredData = ({ post, comments, buildDeepLink, }) => {
    if (post.commentingType !== COMMENTING_TYPE_VOTE) {
        return {};
    }
    const mapCommentToAnswer = (comment) => {
        var _a;
        return ({
            upvoteCount: comment.upvoteCount,
            createdDate: comment.createdDate,
            contentText: 'nodes' in comment.content
                ? toPlainTextSync(comment.content, toPlainTextOptions)
                : toPlainText(comment.content),
            url: buildDeepLink(comment._id),
            owner: (_a = comment.owner) === null || _a === void 0 ? void 0 : _a.name,
        });
    };
    const bestId = post.bestAnswerCommentId;
    const acceptedAnswer = comments
        .filter((comment) => !comment.parentId)
        .filter((comment) => comment._id === bestId)
        .map(mapCommentToAnswer);
    const suggestedAnswer = comments
        .slice(0, 5)
        .filter((c) => c._id !== bestId)
        .map(mapCommentToAnswer);
    return {
        suggestedAnswer,
        acceptedAnswer: bestId ? acceptedAnswer : [],
    };
};
const extractMediaItems = ({ content, videoUploadDate, }) => {
    let mediaItems = [];
    try {
        mediaItems = getMediaData(content);
    }
    catch (e) {
        console.log('Error while extracting media', e);
    }
    return mediaItems.map((mediaItem) => {
        var _a;
        return mediaItem.type === 'video'
            ? Object.assign(Object.assign({}, mediaItem), { uploadDate: (_a = mediaItem.uploadDate) !== null && _a !== void 0 ? _a : videoUploadDate }) : mediaItem;
    });
};
//# sourceMappingURL=decorate-post-with-seo-attributes.js.map